<template>
  <div class="pagination-component">
    <div class="d-flex align-center justify-space-between pt-4 hidden-xs-only">
      <div class="d-flex align-center pagination-block">
        <span class="ml-2">نمایش ردیف:</span>
        <v-text-field v-model="newPageSize" hide-details outlined rounded dense type="number" class="fotter-input"
          @keyup.enter="changePageSize()"
          oninput="if(Number(this.value) > 50) this.value = 50; if(Number(this.value) < 1) this.value = 1;" />
        <v-btn small fab class="mr-2" color="lightColor" elevation="0" @click="changePageSize()">
          <v-icon color="white">mdi-arrow-left-thin</v-icon>
        </v-btn>
      </div>

      <div class="d-flex align-center justify-center flex-grow-1">
        <v-pagination v-model="currentPage" circle color="lightColor" :length="totalPages" :total-visible="8"
          prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right" />
      </div>

      <div class="d-flex align-center pagination-block">
        <span class="mx-3">صفحه {{ currentPage }} از {{ totalPages }}</span>
        <span class="ml-2">برو به:</span>
        <v-text-field v-model="newPageNumber" :max="totalPages" hide-details outlined rounded dense type="number"
          class="fotter-input" @keyup.enter="changePage()" />
        <v-btn small fab class="mr-2" color="lightColor" elevation="0" @click="changePage()">
          <v-icon color="white">mdi-arrow-left-thin</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="hidden-sm-and-up mt-5">
      <div class="text-center mb-4">
        <slot name="action" />
      </div>

      <div class="d-flex align-center justify-space-between">
        <div class="d-flex align-center pagination-block-mobile">
          <span class="mobile-text ml-1">نمایش ردیف:</span>
          <v-text-field v-model="newPageSize" hide-details solo dense type="number" class="fotter-input"
            @keyup.enter="changePageSize(newPageSize)"
            oninput="if(Number(this.value) > 50) this.value = 50; if(Number(this.value) < 1) this.value = 1;" />
          <v-btn small class="mr-1" color="white" @click="changePageSize(newPageSize)">
            <v-icon color="#0D296E">mdi-arrow-left-thin</v-icon>
          </v-btn>
        </div>

        <div class="d-flex align-center pagination-block-mobile">
          <span class="mobile-text">صفحه {{ page }} از {{ totalPages }}</span>
          <v-divider vertical inset class="go-to-page-divider mx-2" />
          <span class="mobile-text">برو به:</span>
          <v-text-field v-model="newPageNumber" :max="100" hide-details solo dense type="number" class="fotter-input"
            @keyup.enter="changePage(newPageNumber)" />
          <v-btn small class="mr-1" color="white" @click="changePage(newPageNumber)">
            <v-icon color="#0D296E">mdi-arrow-left-thin</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaginationComponent',
  props: {
    totalPages: {
      type: Number,
      default: 0,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  mounted() { },
  created() {
    this.$root.$refs.paginationComponent = this;
  },
  data() {
    return {
      currentPage: this.value?.PageNumber || 1,
      pageSize: this.value?.PageSize || 10,
      newPageSize: 10,
      newPageNumber: 1,
    };
  },
  methods: {
    changePage: function (pageNo = +this.newPageNumber) {
      this.$emit('input', { ...this.value, PageNumber: pageNo });
    },
    changePageSize: function (pageSizeNo = +this.newPageSize) {
      this.$emit('input', { PageNumber: 1, PageSize: pageSizeNo });
    },
    resetCurrentPage: function () {
      this.currentPage = 1;
    },
  },
  computed: {},
  watch: {
    currentPage: function (currentVal) {
      if (this.value.PageNumber !== currentVal) {
        this.changePage(currentVal);
      }
    },
    pageSize: function (currentVal) {
      this.changePageSize(currentVal);
    },
    'value.PageNumber': function (newPage) {
      if (newPage !== this.currentPage) {
        this.currentPage = newPage;
        // this.changePage(newPage);
      }
    },
  },
};
</script>

<style scoped>
.pagination-block {
  min-width: 0;
}

.pagination-block .fotter-input {
  max-width: 90px;
}

.pagination-block-mobile .fotter-input {
  max-width: 70px;
}

.go-to-page-divider {
  height: 5vh;
}

.mobile-text {
  font-size: 10px !important;
}

>>>.fotter-input input {
  font-size: 11px !important;
  padding: 0 !important;
  text-align: center;
}

>>>.v-pagination__item {
  box-shadow: none !important;
  background: transparent;
  font-size: 13px !important;
  font-weight: bold !important;
}

>>>.v-pagination__navigation {
  box-shadow: none !important;
  background: none !important;
  border-radius: 50% !important;
  background-color: #8e8e8e !important;
}

>>>.v-pagination__navigation--disabled {
  background-color: transparent !important;
}

>>>.v-pagination__navigation--disabled .mdi-chevron-right,
>>>.v-pagination__navigation--disabled .mdi-chevron-left {
  background-color: transparent !important;
  margin-top: 0;
  margin-bottom: 0;
  padding: 10px;
  color: #0d296e;
}

>>>.v-pagination__navigation--disabled .mdi-chevron-right {
  margin-right: -8px;
}

>>>.v-pagination__navigation--disabled .mdi-chevron-left {
  margin-left: -8px;
}
</style>